import { FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { TEACHER_CONST } from '../../../auth/login/LoginReducer';
import { PARAMS_USUARIOS } from '../UsuariosReducer';
import SelectRolesUsuarios from './SelectRolesUsuarios';

const FiltrosUsuariosComponent = () => {
  const dispatch = Redux.useDispatch();

  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <SelectRolesUsuarios
          value={usuariosStore.params.rol}
          onChanged={(rol) => {
            dispatch({
              type: PARAMS_USUARIOS,
              payload: {
                ...usuariosStore.params,
                rol,
                admin: rol === TEACHER_CONST ? false : null,
              },
            });
          }}
        />
      </Grid>
      {usuariosStore.params.rol === TEACHER_CONST && (
        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Switch
                checked={usuariosStore.params.admin ?? false}
                onChange={(event) => {
                  dispatch({
                    type: PARAMS_USUARIOS,
                    payload: {
                      ...usuariosStore.params,
                      admin: event.target.checked ? true : null,
                    },
                  });
                }}
              />
            }
            label="El docente es administrador"
          />
        </Grid>
      )}

      {/* <Grid item xs={12} md={12}>
        <SelectFieldPerfilesComponent
          id="select-perfiles-usuarios"
          value={usuariosStore.params.idPerfil}
          onChange={(idPerfil) => {
            dispatch({
              type: PARAMS_USUARIOS,
              payload: {
                ...usuariosStore.params,
                idPerfil,
              },
            });
          }}
        />
      </Grid> */}
    </Grid>
  );
};

export default FiltrosUsuariosComponent;
